<template>
  <div class="message-card">
    <slot name="title">
      <div class="title" v-if="title">
        <label>{{title}}<i style="color: #ff0000" v-if="isRequire">*</i></label>
      </div>
    </slot>
    <slot name="file"></slot>

    <div class="message-info" v-if="info.length">
      <div class="message-info-item" v-for="(item, index) in info" v-if="!!item.text" :key="index">
        <span>{{ item.label }}</span> {{ item.text }}
      </div>
    </div>
   <slot name="info"></slot>
   <slot></slot>
    <slot name="status"></slot>
  </div>
</template>

<script>

export default {
  name: 'MessageCard',
  props: {
    title: String,
    isRequire: Boolean,
    info: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style  lang="postcss">
@import 'variables';

.message-card {
  padding: 4px 16px;
  border-radius: 8px;
  background: #FFF;
  position: relative;
  margin-bottom: 12px;

  & .title {
    font-size: 14px;
    display: flex;
    padding: 12px 0;
    color: var(--fontBasicColor);
    font-weight: 400;
    justify-content: space-between;
    align-items: center;
    & label,
    & span {
      display: flex;
      color: var(--fontBasicColor);
    }
    & label {
      line-height: 24px;
      font-size: 16px;
    }
  }

  & .message-info {
    border-top: 1px solid #EBF0F5;
    padding: 12px 0 10px 0;

    & .message-info-item {
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #9BA7BA;
      margin-bottom: 2px;
      display: flex;
      color: #626F84;
      & span {
        display: flex;
        min-width: 48px;
        width: 48px;
        margin-right: 16px;
        color: #9BA7BA;
      }
    }
  }

  & .review-status {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 104px;
    height: 104px;
    border-radius: 8px;

    & span {
      position: absolute;
      font-size: 12px;
      font-family: PingFang SC;
      transform: rotate(-34deg);
      width: 104px;
      display: block;
      top: 50%;
      margin-top: -9px;
      left: 50%;
      margin-left: -52px;
      text-align: center;
    }

    &.rejected,
    &.returned {
      & span {
        color: #FF4D48;
      }
    }

    &.passed {
      & span {
        color: #07C160;
      }
    }

    &.closed,
    &.invalid {
      & span {
        color: #9BA0B4;
      }
    }

    &.processing {
      & span {
        color: #FFA31A;
      }
    }

  }

}

</style>
